import request from '@/common/request'

class SegmentoService {
  getAll() {
    return request.get('/segmentos')
  }

  create(data) {
    return request.post('/segmentos', data)
  }

  update(id, data) {
    return request.patch(`/segmentos/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/segmentos/${id}`)
  }
}

export default new SegmentoService()
